import moment from "moment";
import { CourseType } from "../../config/COURSE_TYPE_CONFIG";
import { coursesPath } from "../CourseEditV2/paths";

/**
 * Onglets de « Mes cours » repensé (maquettes 6a, 6b, 6c du 1er novembre 2026),
 * portés par l'URL : `?onglet=a-venir|ce-mois|passes|brouillons`.
 */
export type CoursesTab = "a-venir" | "ce-mois" | "passes" | "brouillons";

export const COURSES_TAB_PARAM = "onglet";
/** Période de l'onglet Passés : `YYYY-MM`, ou `toutes`. */
export const COURSES_PERIOD_PARAM = "periode";
export const ALL_PERIODS = "toutes";

export const COURSES_TABS: CoursesTab[] = ["a-venir", "ce-mois", "passes", "brouillons"];
export const DEFAULT_COURSES_TAB: CoursesTab = "ce-mois";

/** Numéros de composant de l'ancien écran (`location.state`), encore envoyés par l'accueil et la fin de déclaration. */
export const TAB_FROM_LEGACY_STATE: Record<number, CoursesTab> = { 9: "a-venir", 1: "ce-mois", 2: "passes", 3: "brouillons" };

/** Type de liste (hook `useListCourse`) de chaque onglet, hors brouillons. */
export const TAB_COURSE_TYPE: Record<Exclude<CoursesTab, "brouillons">, Exclude<CourseType, "brouillon">> = {
    "a-venir": "avenir",
    "ce-mois": "actif",
    passes: "historique",
};

export const isCoursesTab = (value: string | null | undefined): value is CoursesTab =>
    !!value && (COURSES_TABS as string[]).includes(value);

export const coursesTabPath = (tab: CoursesTab): string => `${coursesPath()}?${COURSES_TAB_PARAM}=${tab}`;

/** Onglet Historique (`passes`), sur un mois `YYYY-MM` si précisé. */
export const coursesHistoryPath = (period?: string): string =>
    `${coursesTabPath("passes")}${period && isMonthPeriod(period) ? `&${COURSES_PERIOD_PARAM}=${period}` : ""}`;

/** Mois courant au format de l'URL : « 2026-11 ». */
export const currentPeriod = (): string => moment().format("YYYY-MM");

export const isMonthPeriod = (period: string): boolean => /^\d{4}-(0[1-9]|1[0-2])$/.test(period);

/** Bornes d'une période (mois ou toutes) au format attendu par l'API des cours passés. */
export const periodBounds = (period: string): { start: string; end: string } => {
    if (isMonthPeriod(period)) {
        const m = moment(period, "YYYY-MM");
        return { start: m.startOf("month").format("YYYY-MM-DD 00:00:00"), end: m.endOf("month").format("YYYY-MM-DD 23:59:59") };
    }
    return { start: "2000-01-01 00:00:00", end: moment().endOf("day").format("YYYY-MM-DD 23:59:59") };
};

/** Mois proposés dans le sélecteur de période : du mois courant jusqu'à deux ans en arrière. */
export const periodOptions = (monthsBack = 24): string[] =>
    Array.from({ length: monthsBack + 1 }, (_, i) => moment().subtract(i, "month").format("YYYY-MM"));
